import Main from '../views/main';
import { notAllow, notFind } from 'rjelement-components';
// import menuCommonFactory from '@rui-jie/webmenucommonfactory';
import menuCommonFactory from './webmenucommonfactory';
export const layoutRoute = menuCommonFactory([
  // export const layoutRoute = [
  {
    path: '/',
    component: Main,
    alwaysShow: true,
    name: 'orderLayout',
    meta: {
      title: '订单中心',
      icon: 'iconfont icontoreview'
    },
    children: [
      {
        path: 'ChiefOrderList',
        component: () => import('../views/Chief/order/mainList.vue'),
        name: 'ChiefOrderList',
        meta: {
          title: '订单处理',
          qx: 2
        }
      },
      {
        path: 'DistributorOrderList',
        component: () => import('../views/distributor/order/mainList.vue'),
        name: 'DistributorOrderList',
        meta: {
          // title: '订单处理(分销商)'
          title: '订单处理',
          qx: 2
        }
      },
      {
        path: 'ChiefContractList',
        component: () => import('../views/Chief/contract/mainList.vue'),
        name: 'ChiefContractList',
        meta: {
          title: '合同处理',
          qx: 2
        }
      },
      {
        path: 'orderPersionContractList',
        component: () => import('../views/orderPersion/contract/mainList.vue'),
        name: 'orderPersionContractList',
        meta: {
          // title: '合同处理(订)'
          title: '合同处理',
          qx: 2
        }
      },
      // {
      //   path: 'orderInternationPersionContractList',
      //   component: () => import('../views/orderPersion/contract/mainInternationList.vue'),
      //   name: 'orderInternationPersionContractList',
      //   meta: {
      //     // title: '合同处理(订)'
      //     title: '合同处理(国际)',
      //     qx: 2
      //   }
      // },
      {
        path: 'businessContractList',
        component: () => import('../views/business/index.vue'),
        name: 'businessContractList',
        meta: {
          // title: '合同处理(商务)'
          title: '合同处理（商务）',
          qx: 2
        }
      },
      {
        path: 'PendingBatchInfo/:contractNum',
        component: () => import('../views/business/details/PendingBatchInfo.vue'),
        name: 'PendingBatchInfo',
        meta: {
          title: '待确认批次发货申请'
        }
      },
      {
        path: 'OverseasBatchPaymentManagement',
        component: () => import('../views/OverseasBatchPaymentManagement/index.vue'),
        name: 'OverseasBatchPaymentManagement',
        meta: {
          title: '海外付款管理',
          qx: 2
        }
      },
      {
        path: 'RebateReceivable/approval/:contractNum',
        component: () => import('../views/rebateManagement/approval/index.vue'),
        name: 'RebateReceivableApproval',
        meta: {
          title: '返利抵应收审批'
        }
      },
      {
        path: 'PendingBatchPaymentDetails/:contractNum',
        component: () => import('../views/OverseasBatchPaymentManagement/components/PendingBatchPaymentDetails.vue'),
        name: 'PendingBatchPaymentDetails',
        meta: {
          title: '待审批批次付款明细'
        }
      },
      {
        path: 'freightForwarder',
        component: () => import('../views/freight-forwarder/index.vue'),
        name: 'freightForwarder',
        meta: {
          title: '货代信息配置',
          qx: 2
        }
      },
      {
        path: 'orderPersionDrafts',
        component: () => import('../views/orderPersion/drafts'),
        name: 'orderPersionDrafts',
        meta: {
          title: '草稿箱',
          qx: 2
        }
      },
      {
        path: '/sparePartsContract/details/:contractNum',
        component: () => import('../views/sparePartsContract/details/index.vue'),
        name: 'sparePartsContractDetails',
        props: true,
        meta: {
          // 商务
          title: '合同详情'
        }
      },
      {
        path: 'sparePartsContract',
        component: () => import('../views/sparePartsContract/index'),
        name: 'sparePartsContract',
        meta: {
          title: '海外备件合同管理',
          qx: 2
        }
      },
      {
        path: 'assistantContractList',
        component: () => import('../views/assistantContractList/assistantContractList.vue'),
        name: 'assistantContractList',
        meta: {
          title: '合同查询',
          qx: 2
        }
      },
      {
        path: '/distributionSw/:contractNum',
        props: true,
        name: 'distributionSw',
        component: () => import('../views/assistantContractList/distribution.vue'),
        meta: {
          title: '合同-分配款项'
          // qx: 2
        }
      },
      {
        path: 'checkManagement',
        component: () => import('../views/assistantContractList/checkManagement'),
        name: 'checkManagement',
        meta: {
          title: '合同查询'
        }
      },
      // 国际退换货海外销售发起申请
      {
        path: 'refundsAndExchangesApplication',
        component: () => import('../views/InterOrderReturnExchangeSales/index.vue'),
        name: 'refundsAndExchangesApplication',
        props: true,
        meta: {
          title: '退换货申请(海外销售)'
        }
      }
      // {
      //   path: 'creditTransfer',
      //   component: () => import('../views/Finance/creditTransfer/index.vue'),
      //   name: 'creditTransfer',
      //   meta: {
      //     title: '债权管理',
      //     qx: 2
      //   }
      // }
      // {
      //   path: 'orderBoard',
      //   component: () => import('../views/order-board/index.vue'),
      //   name: 'orderBoard',
      //   meta: {
      //     title: '订单看板'
      //   }
      // }
    ]
  },
  {
    path: '/',
    component: Main,
    name: 'agent_thh',
    alwaysShow: true,
    meta: {
      title: '退换货管理',
      icon: 'iconfont iconmoney'
    },
    children: [
      {
        path: 'returnExchangeChief',
        component: () => import('../views/returnExchange/Chief/index.vue'),
        name: 'agent_thh_list',
        meta: {
          title: '退换货合同处理(代理商)',
          qx: 2
        }
      },
      {
        path: 'chiefReturnbHandel',
        component: () => import('../views/returnExchange/Chief/commom/handel.vue'),
        name: 'chiefReturnbHandel',
        meta: {
          title: '退换货合同办理'
        }
      },
      {
        path: 'chiefReturnbFile',
        component: () => import('../views/returnExchange/Chief/commom/contractFile.vue'),
        name: 'chiefReturnbFile',
        meta: {
          title: '退换货合同签章'
        }
      },
      {
        path: 'chiefReturnbPay',
        component: () => import('../views/returnExchange/Chief/commom/pay.vue'),
        name: 'chiefReturnbPay',
        meta: {
          title: '退换货合同分配'
        }
      },
      {
        path: 'internationalPay',
        component: () => import('../views/business/components/internationalPay.vue'),
        name: 'internationalPay',
        meta: {
          title: '退换货合同分配'
        }
      },
      {
        path: 'chiefReturnbHandelChange',
        component: () => import('../views/returnExchange/Chief/commom/handelChange.vue'),
        name: 'chiefReturnbHandelChange',
        meta: {
          title: '退换货合同办理'
        }
      },
      {
        path: 'financeThhList',
        component: () => import('../views/returnExchange/financeThhList/index.vue'),
        name: 'finance_thh_list',
        meta: {
          title: '退换货合同处理(财务)',
          qx: 2
        }
      },
      {
        path: 'financeThhListHandel',
        component: () => import('../views/returnExchange/financeThhList/common/handel.vue'),
        name: 'financeThhListHandel',
        meta: {
          title: '财务退换货合同办理'
        }
      },
      {
        path: 'orderPersionChangeHandel/:contractNum',
        component: () => import('../views/orderPersion/contract/common/handel.vue'),
        name: 'orderPersionChangeHandel',
        meta: {
          title: '订单员退换货办理'
        }
      },
      {
        path: 'checkHt',
        component: () => import('../views/returnExchange/Chief/commom/checkHt.vue'),
        name: 'checkHt',
        meta: {
          title: '合同查看'
        }
      },
      {
        path: 'checkHtChange',
        component: () => import('../views/returnExchange/Chief/commom/checkHtChange.vue'),
        name: 'checkHtChange',
        meta: {
          title: '合同查看'
        }
      },
      {
        path: 'checkInternationalChange',
        component: () =>
          import('../views/returnExchange/Chief/commom/checkInternationalChange.vue'),
        name: 'checkInternationalChange',
        meta: {
          title: '合同查看'
        }
      }
    ]
  },
  {
    path: '/',
    component: Main,
    name: 'FinanceLayout',
    alwaysShow: true,
    meta: {
      title: '账务管理',
      icon: 'iconfont iconmoney'
    },
    children: [
      {
        path: 'RemittanceList',
        component: () => import('../views/Finance/wire-transfer-query/Index.vue'),
        name: 'RemittanceList',
        meta: {
          // title: '电汇查询（代理商）'
          title: '电汇查询',
          qx: 2
        }
      }, {
        path: 'FinanceRemittanceList',
        component: () => import('../views/Finance/index.vue'),
        name: 'FinanceRemittanceList',
        meta: {
          // title: '电汇查询（财务）'
          title: '电汇查询',
          qx: 2
        }
      }, {
        // FE-001：国际退款新菜单（禁止改 FinanceRemittanceList）
        path: 'OverseasRefundList',
        component: () => import('../views/Finance/overseas-refund/Index.vue'),
        name: 'OverseasRefundList',
        meta: {
          title: '国际退款',
          qx: 2
        }
      }, {
        path: 'businessList',
        component: () => import('../views/businessList/index.vue'),
        name: 'businessList',
        meta: {
          title: '电汇查询',
          qx: 2
        }
      },
      {
        path: 'remittanceEntryBusiness',
        component: () => import('../views/Finance/remittanceEntryBusiness.vue'),
        name: 'remittanceEntryBusiness',
        meta: {
          // title: '汇款录入（商务）'
          title: '汇款录入',
          qx: 2
        }
      },
      // {
      //   path: 'settlementQuery',
      //   component: () => import('../views/Finance/settlementQuery/index.vue'),
      //   name: 'settlementQuery',
      //   meta: {
      //     title: '直签报账管理',
      //     qx: 2
      //   }
      // },
      // {
      //   path: 'invoiceNoticeManagement',
      //   component: () => import('../views/Finance/invoiceNoticeManagement/index.vue'),
      //   name: 'invoiceNoticeManagement',
      //   meta: {
      //     title: '开票通知单管理',
      //     qx: 2
      //   }
      // },
      // {
      //   path: 'orderClerkWireTransferAllocation',
      //   component: () => import('../views/Finance/orderClerkWireTransferAllocation/index.vue'),
      //   name: 'orderClerkWireTransferAllocation',
      //   meta: {
      //     title: '订单员电汇分配',
      //     qx: 2
      //   }
      // },
      {
        path: 'reconciliationManagement',
        component: () => import('../views/Finance/reconciliationManagement.vue'),
        name: 'reconciliationManagement',
        meta: {
          // title: '对账单管理'
          title: '对账单管理',
          qx: 2
        }
      },
      //
      {
        path: 'fundInquiry',
        component: () => import('../views/Finance/fundInquiry.vue'),
        name: 'fundInquiry',
        meta: {
          // title: '资金查询'
          title: '资金查询',
          qx: 2
        }
      },
      {
        path: 'fundClaim',
        component: () => import('../views/Finance/fundClaim.vue'),
        name: 'fundClaim',
        meta: {
          // title: '资金认领'
          title: '资金认领',
          qx: 2
        }
      }, {
        path: 'fundManagement',
        component: () => import('../views/Finance/fundManagement.vue'),
        name: 'fundManagement',
        meta: {
          // title: '修改客户名称审核'
          title: '修改客户名称审核',
          qx: 2
        }
      },
      // {
      //   path: 'openTicketManagmentOfcontractAsWhole',
      //   component: () => import('../views/Finance/openTicketManagmentOfcontractAsWhole/Index.vue'),
      //   name: 'openTicketManagmentOfcontractAsWhole',
      //   meta: {
      //     // title: '开票管理(合同统筹)'
      //     title: '开票管理(合同统筹)',
      //     qx: 2
      //   }
      // },
      {
        path: 'openTicketManagmentOfOrder',
        component: () => import('../views/Finance/openTicketManagmentOfOrder/Index.vue'),
        name: 'openTicketManagmentOfOrder',
        meta: {
          title: '开票管理(订单员)',
          qx: 2
        }
      }, {
        path: 'openTicketManagmentOfFinancial',
        component: () => import('../views/Finance/openTicketManagmentOfFinancial/Index.vue'),
        name: 'openTicketManagmentOfFinancial',
        meta: {
          title: '开票管理(财务)',
          qx: 2
        }
      }, {
        path: 'claimParagraphErrorDual',
        component: () => import('../views/Finance/claimParagraphErrorDual/index.vue'),
        name: 'claimParagraphErrorDual',
        meta: {
          title: '撤销分配记录审核',
          qx: 2
        }
      }, {
        path: 'toParagraphErrorDual',
        component: () => import('../views/Finance/toParagraphErrorDual/index.vue'),
        name: 'toParagraphErrorDual',
        meta: {
          title: '作废来款单审核',
          qx: 2
        }
      },
      {
        path: 'electronicInvoiceInquiry',
        component: () => import('../views/Finance/electronic-invoice-inquiry'),
        name: 'agent_my_invoice',
        meta: {
          title: '我的发票',
          qx: 2
        }
      }

    ]
  },
  {
    path: '/',
    component: Main,
    name: 'LogisticsManagement',
    alwaysShow: true,
    meta: {
      title: '国际物流管理',
      icon: 'iconfont iconmoney'
    },
    children: [
      {
        path: '/internationalLogisticsInfo',
        component: () => import('../views/logistics/international/index.vue'),
        name: 'LogisticsInternational',
        meta: {
          title: '国际物流信息',
          qx: 2
        }
      },
      {
        path: '/shipmentCustomsApprovalMenu',
        component: () => import('../views/InternationalInvoiceProcessing/index.vue'),
        name: 'shipmentCustomsApprovalMenu',
        meta: {
          title: '发货单处理',
          qx: 2
        }
      }
    ]
  },
  {
    path: '/',
    component: Main,
    name: 'orderPerson',
    alwaysShow: true,
    meta: {
      title: '权限管理',
      icon: 'iconfont iconquanxian'
    },
    children: [
      {
        path: 'orderPersonLimit',
        component: () => import('../views/limitManagement/orderPersonLimit/orderPersonLimit.vue'),
        name: 'orderPersonLimit',
        meta: {
          title: '订单员权限',
          qx: 2
        }
      },
      {
        path: 'userPermissionConfig',
        component: () => import('../views/limitManagement/userPermissionConfig/index.vue'),
        name: 'userPermissionConfig',
        meta: {
          title: '用户菜单权限配置',
          qx: 2
        }
      },
      {
        path: 'cesUserRoleConfig',
        component: () => import('../views/limitManagement/cesUserRoleConfig/index.vue'),
        name: 'cesUserRoleConfig',
        meta: {
          title: 'CES角色审批人配置',
          qx: 2
        }
      },
      {
        path: 'sysDictDataConfig',
        component: () => import('../views/limitManagement/sysDictDataConfig/index.vue'),
        name: 'sysDictDataConfig',
        meta: {
          title: '字典字段管理',
          qx: 2
        }
      }
    ]
  },
  {
    path: '/',
    component: Main,
    name: 'businessPermissionManagement',
    alwaysShow: true,
    meta: {
      title: '商务权限管理',
      icon: 'iconfont iconquanxian'
    },
    children: [
      {
        path: 'businessShipList',
        component: () => import('../views/businessManage/businessManagement/index.vue'),
        name: 'businessShipList',
        meta: {
          title: '区域部门列表',
          qx: 2
        }
      },
      {
        path: 'businessShipCopyList',
        component: () => import('../views/businessManage/ruleCopy/index.vue'),
        name: 'businessShipCopyList',
        meta: {
          title: '权限复制',
          qx: 2
        }
      }
    ]
  },
  {
    path: '/',
    component: Main,
    name: 'agentOverdueManagement',
    alwaysShow: true,
    meta: {
      title: '客户超期管理',
      icon: 'iconfont iconquanxian'
    },
    children: [
      {
        path: 'agentOverdueList',
        component: () => import('../views/agentOverdue/index.vue'),
        name: 'agentOverdueList',
        meta: {
          title: '客户超期查询',
          qx: 2
        }
      }
    ]
  },
  // {
  //   path: '/',
  //   component: Main,
  //   name: 'CreditManagement',
  //   alwaysShow: true,
  //   meta: {
  //     title: '信用管理',
  //     icon: 'iconfont iconquanxian'
  //   },
  //   children: [
  //     {
  //       path: 'ListManagement',
  //       component: () => import('../views/CreditManagement/ListManagement/index.vue'),
  //       name: 'ListManagement',
  //       meta: {
  //         title: '黄黑名单管理',
  //         qx: 2
  //       }
  //     }
  //   ]
  // },
  {
    path: '/',
    component: Main,
    name: 'markManager',
    alwaysShow: true,
    meta: {
      title: '唛头管理',
      icon: 'iconfont iconquanxian'
    },
    children: [
      {
        path: 'generalTemplateManagement',
        component: () => import('../views/markManager/generalTemplateManagement/index.vue'),
        name: 'generalTemplateManagement',
        meta: {
          title: '通用唛头管理',
          qx: 2
        }
      },
      {
        path: 'personalizedTemplateManagement',
        component: () => import('../views/markManager/personalizedTemplateManagement/index.vue'),
        name: 'personalizedTemplateManagement',
        meta: {
          title: '个性模板管理',
          qx: 2
        }
      },
      {
        path: 'addPersonalizedTemplate',
        component: () => import('../views/markManager/personalizedTemplateManagement/components/addTemplate/index.vue'),
        name: 'addPersonalizedTemplate',
        meta: {
          title: '新增个性模板',
          active: 'personalizedTemplateManagement'
        }
      },
      {
        path: 'markPrinting',
        component: () => import('../views/markManager/markPrinting/index.vue'),
        name: 'markPrinting',
        meta: {
          title: '唛头打印',
          qx: 2
        }
      }
    ]
  },
  {
    path: '/',
    component: Main,
    name: 'batteryCertificationManagement',
    alwaysShow: true,
    meta: {
      title: '电池认证管理',
      icon: 'iconfont icon-keqi'
    },
    children: [
      {
        path: 'batteryCertificationManagement',
        name: 'batteryCertificationManagement',
        meta: {
          title: '认证台账',
          qx: 2
        },
        component: () => import('../views/batteryCertificationManagement/index.vue')
      }
    ]
  },
  {
    path: '/',
    component: Main,
    name: 'expectedDeliveryDateManager',
    alwaysShow: true,
    meta: {
      title: '客期变更管理',
      icon: 'iconfont icon-keqi'
    },
    children: [
      {
        path: 'expectedDeliveryDateApplyList',
        name: 'expectedDeliveryDateApplyList',
        meta: {
          title: '我的申请单',
          qx: 2
        },
        component: () => import('../views/ExpectedDeliveryDate/ApplyList/index.vue')
      },
      {
        path: 'expectedDeliveryDateApproveList',
        name: 'expectedDeliveryDateApproveList',
        meta: {
          title: '我的审批单',
          qx: 2
        },
        component: () => import('../views/ExpectedDeliveryDate/ApproveList/index.vue')
      }
    ]
  },
  {
    path: '/',
    component: Main,
    name: 'creditCenter',
    alwaysShow: true,
    meta: {
      title: '信控中心',
      icon: 'iconfont iconquanxian'
    },
    children: [
      {
        path: 'creditControlApplicationList',
        component: () => import('../views/creditCenter/myApplicationList/index.vue'),
        name: 'creditControlApplicationList',
        meta: {
          title: '我的申请',
          qx: 2
        }
      },
      {
        path: 'creditControlDraftList',
        component: () => import('../views/creditCenter/myDraftList/index.vue'),
        name: 'creditControlDraftList',
        meta: {
          title: '我的草稿',
          qx: 2
        }
      },
      {
        path: 'creditQuotaInquiryList',
        component: () => import('../views/creditCenter/myQuotaInquiry/index.vue'),
        name: 'creditQuotaInquiryList',
        meta: {
          title: '额度查询',
          qx: 2
        }
      }
    ]
  }
], Main);
// ];
const otherMainLayout = [
  {
    path: '/',
    component: Main,
    name: 'otherLayout',
    meta: {
      title: '订单中心',
      icon: 'iconfont icontoreview'
    },
    children: [
      {
        path: 'behaviorReplay',
        component: () => import('../views/behaviorReplay/index.vue'),
        name: 'behaviorReplay',
        meta: {
          title: '用户行为回放',
          active: 'ChiefOrderList'
        }
      },
      {
        path: 'behaviorReplay/:sessionId',
        props: true,
        component: () => import('../views/behaviorReplay/detail.vue'),
        name: 'behaviorReplayDetail',
        meta: {
          title: '行为回放详情',
          active: 'behaviorReplay'
        }
      },
      {
        path: 'ChiefOrderPriceDoIt/:documentID',
        props: true,
        component: () => import('../views/Chief/order/handlePrice/doIt.vue'),
        name: 'ChiefOrderPriceDoIt',
        meta: {
          title: '订单处理-确认价格',
          active: 'ChiefOrderList'
        }
      },
      {
        path: 'ChiefOrderSubjectDoIt/:documentID',
        props: true,
        component: () => import('../views/Chief/order/handleSubject/doIt.vue'),
        name: 'ChiefOrderSubjectDoIt',
        meta: {
          title: '订单处理-确认服务主体',
          active: 'ChiefOrderList'
        }
      },
      {
        path: 'ChiefOrderPriceInfo/:documentID',
        props: true,
        component: () => import('../views/Chief/order/handlePrice/info.vue'),
        name: 'ChiefOrderPriceInfo',
        meta: {
          title: '订单详情',
          active: 'ChiefOrderList'
        }
      },
      {
        path: 'ChiefOrderSubjectInfo/:documentID',
        props: true,
        component: () => import('../views/Chief/order/handleSubject/info.vue'),
        name: 'ChiefOrderSubjectInfo',
        meta: {
          title: '订单详情',
          active: 'ChiefOrderList'
        }
      },
      {
        path: 'DistributorOrderPrice/:documentID',
        props: true,
        component: () => import('../views/distributor/order/handlePrice/doIt.vue'),
        name: 'DistributorOrderPrice',
        meta: {
          title: '订单处理-确认价格',
          active: 'DistributorOrderList'
        }
      },
      {
        path: 'DistributorOrderSubject/:documentID',
        props: true,
        component: () => import('../views/distributor/order/handleSubject/doIt.vue'),
        name: 'DistributorOrderSubject',
        meta: {
          title: '订单处理-确认服务主体',
          active: 'DistributorOrderList'
        }
      },
      {
        path: 'FirstDistributorOrder/:documentId',
        props: true,
        component: () => import('../views/distributor/order/first/firstInfo.vue'),
        name: 'FirstDistributorOrder',
        meta: {
          title: '优选服务商确认',
          active: 'ChiefOrderList'
        }
      },
      {
        path: 'DistributorOrderPriceInfo/:documentID',
        component: () => import('../views/distributor/order/handlePrice/info.vue'),
        props: true,
        name: 'DistributorOrderPriceInfo',
        meta: {
          title: '订单信息',
          active: 'DistributorOrderList'
        }
      },
      {
        path: 'DistributorOrderSubjectInfo/:documentID',
        component: () => import('../views/distributor/order/handleSubject/info.vue'),
        props: true,
        name: 'DistributorOrderSubjectInfo',
        meta: {
          title: '订单信息',
          active: 'DistributorOrderList'
        }
      },
      {
        path: 'firstDistributorOrderInfo/:documentId',
        component: () => import('../views/distributor/order/first/firstInfo.vue'),
        props: true,
        name: 'firstDistributorOrderInfo',
        meta: {
          title: '订单信息',
          active: 'DistributorOrderList'
        }
      },
      {
        path: 'logistics/:contractNum/',
        props: true,
        component: () => import('../views/Chief/order/complete/logistics.vue'),
        name: 'logistics',
        meta: {
          title: '查看物流',
          active: 'ChiefOrderList'
        }
      },
      {
        path: 'doSeal/:contractNum',
        component: () => import('../views/Chief/contract/doSeal.vue'),
        name: 'doSeal',
        props: true,
        meta: {
          title: '合同附件信息',
          active: 'ChiefContractList'
        }
      },
      {
        path: '/contractAgreement/:contractNum',
        name: 'contractAgreement',
        props: true,
        component: () => import('../views/Chief/contract/contractAgreementPrint.vue'),
        meta: {
          title: '打印合同',
          active: 'ChiefContractList'
        }
      },
      {
        path: '/Submission/:contractNum',
        name: 'Submission',
        props: true,
        component: () => import('../views/Chief/contract/Submission/index.vue'),
        meta: {
          title: '合同-待提交',
          active: 'ChiefContractList'
        }
      },
      {
        path: '/distribution/:contractNum',
        props: true,
        name: 'distribution',
        component: () => import('../views/Chief/contract/distribution.vue'),
        meta: {
          title: '合同-分配款项',
          active: 'ChiefContractList'
        }
      },
      {
        path: 'ContractInfo/:contractNum',
        component: () => import('../views/Chief/contract/complete/index.vue'),
        name: 'ContractInfo',
        props: true,
        meta: {
          title: '合同详细',
          active: 'ChiefContractList'
        }
      },
      {
        path: 'BatchBase',
        component: () => import('../views/Chief/contract/BatchBase/index.vue'),
        name: 'BatchBase',
        props: true,
        meta: {
          title: '分批发货基本信息',
          active: 'ChiefContractList'
        }
      },
      {
        path: 'FinanceBatchBase',
        component: () => import('../views/Finance/components/BatchBase/index.vue'),
        name: 'FinanceBatchBase',
        props: true,
        meta: {
          title: '资金认领分配',
          active: 'ChiefContractList'
        }
      },
      {
        path: 'distributionRemittance/:teleNum',
        name: 'distributionRemittance',
        props: true,
        component: () => import('../views/Finance/distribution.vue'),
        meta: {
          title: '电汇-款项分配',
          active: 'RemittanceList'
        }
      },
      {
        path: 'Finance/international/confirmReceipt/:id',
        component: () => import('../views/Finance/international/handle'),
        name: 'ConfirmReceipt',
        meta: {
          title: '确认收款'
        }
      },
      {
        path: 'orderPersionContractCreatDomestic',
        component: () => import('../views/orderPersion/createContract/domestic/index.vue'),
        name: 'orderPersionContractCreatDomestic',
        meta: {
          title: '创建合同',
          active: 'orderPersionContractList'
        }
      },
      {
        path: 'orderPersionContractCreatInternational',
        component: () => import('../views/orderPersion/createContract/international'),
        name: 'orderPersionContractCreatInternational',
        meta: {
          title: '创建合同',
          active: 'orderPersionContractList'
        }
      },
      {
        path: 'orderPersionContractHandledraftsInternational/:contractNum',
        props: true,
        component: () => import('../views/orderPersion/handledrafts/international'),
        name: 'orderPersionContractHandledraftsInternational',
        meta: {
          title: '编辑草稿',
          active: 'orderPersionDrafts'
        }
      },
      {
        path: 'orderPersionContractHandledraftsDomestic/:contractNum',
        component: () => import('../views/orderPersion/handledrafts/domestic/index.vue'),
        name: 'orderPersionContractHandledraftsDomestic',
        props: true,
        meta: {
          title: '编辑草稿',
          active: 'orderPersionDrafts'
        }
      },
      {
        path: 'handleContractquery/:contractNum',
        component: () => import('../views/assistantContractList/handleContractquery/index.vue'),
        name: 'handleContractquery',
        props: true,
        meta: {
          title: '编辑草稿',
          active: 'handleContractquery'
        }
      },
      {
        path: 'orderPersionContractInfo/:contractNum',
        component: () => import('../views/orderPersion/complete/index.vue'),
        name: 'orderPersionContractInfo',
        props: true,
        meta: {
          title: '合同详细',
          active: 'orderPersionContractList'
        }
      },
      {
        path: 'orderPersionContractHandlerInternational/:contractNum',
        props: true,
        component: () => import('../views/orderPersion/handler/international'),
        name: 'orderPersionContractHandlerInternational',
        meta: {
          title: '办理合同',
          active: 'orderPersionContractList'
        }
      },
      {
        path: 'orderPersionContractHandlerDomestic/:contractNum',
        component: () => import('../views/orderPersion/handler/domestic/index.vue'),
        name: 'orderPersionContractHandlerDomestic',
        props: true,
        meta: {
          title: '办理合同',
          active: 'orderPersionContractList'
        }
      },
      // 换货办理
      {
        path: 'orderPersionContractHandlerChangeDomestic',
        component: () => import('../views/orderPersion/handlerChange/domestic/index.vue'),
        name: 'orderPersionContractHandlerChangeDomestic',
        props: true,
        meta: {
          title: '办理合同',
          active: 'orderPersionContractHandlerChangeDomestic'
        }
      },
      // 退货办理
      {
        path: 'orderPersionContractGoodsReturn',
        component: () => import('../views/orderPersion/returnGoods/index.vue'),
        name: 'orderPersionContractGoodsReturn',
        props: true,
        meta: {
          title: '办理合同',
          active: 'orderPersionContractGoodsReturn'
        }
      },
      {
        path: 'salesBorrowPureServiceReturn/:contractId',
        component: () => import('@/views/salesBorrowPureServiceReturn/index.vue'),
        name: 'salesBorrowPureServiceReturn',
        props: true,
        meta: {
          title: '销售借用纯服务退货',
          active: 'assistantContractList'
        }
      },
      // 待审批国际退货合同办理
      {
        path: 'interOrderReturnExchange',
        component: () => import('../views/interOrderReturnExchange/index.vue'),
        name: 'interOrderReturnExchange',
        props: true,
        meta: {
          title: '国际退换货合同'
        }
      },
      // 已审批国际退换货详情
      {
        path: 'approvedInterOrderReturnExchange',
        component: () => import('../views/approvedInterOrderReturnExchange/index.vue'),
        name: 'approvedInterOrderReturnExchange',
        props: true,
        meta: {
          title: '国际退换货合同'
        }
      },

      {
        path: 'orderPersionContractHandlerService/:contractNum',
        component: () => import('../views/orderPersion/handler/service'),
        name: 'orderPersionContractHandlerService',
        props: true,
        meta: {
          title: '办理合同',
          active: 'orderPersionContractList'
        }
      },
      {
        path: '/business/handler/:contractNum/',
        component: () => import('../views/business/handler/index.vue'),
        name: 'businessHandler',
        props: true,
        meta: {
          // 商务
          title: '办理合同'
        }
      },
      {
        path: '/business/distributionContract',
        component: () => import('../views/business/distribution-contract/index.vue'),
        name: 'businessDistributionContract',
        props: true,
        meta: {
          // 商务
          title: '分配合同'
        }
      },
      {
        path: '/business/patrDetails/:contractNum',
        component: () => import('../views/business/details/partIndex.vue'),
        name: 'businessPartDetails',
        props: true,
        meta: {
          // 商务 国际备件下单合同详情
          title: '合同详情'
        }
      },
      {
        path: '/business/details/:contractNum',
        component: () => import('../views/business/details/index.vue'),
        name: 'businessDetails',
        props: true,
        meta: {
          // 商务
          title: '合同详情'
        }
      },
      // 待分配发货单  distributiondelivery
      {
        path: '/business/distributiondelivery:contractNum',
        component: () => import('../views/business/components/internationalAllocateinvoices.vue'),
        name: 'allocateinvoices',
        props: true,
        meta: {
          // 商务
          title: '待分配发货单'
        }
      },

      // 客期变更申请
      {
        path: 'expectedDeliveryDateApply',
        name: 'expectedDeliveryDateApply',
        props: true,
        meta: {
          title: '客期变更申请',
          active: 'businessContractList'
        },
        component: () => import('../views/ExpectedDeliveryDate/Apply/index.vue')
      },

      // 客期变更审批
      {
        path: 'expectedDeliveryDateApprove',
        name: 'expectedDeliveryDateApprove',
        props: true,
        meta: {
          title: '客期变更审批',
          active: 'expectedDeliveryDateApproveList'
        },
        component: () => import('../views/ExpectedDeliveryDate/Approve/index.vue')
      },
      // 客期变更详情
      {
        path: 'expectedDeliveryDateDetail',
        name: 'expectedDeliveryDateDetail',
        props: true,
        meta: {
          title: '客期变更审批',
          active: 'expectedDeliveryDateApplyList'
        },
        component: () => import('../views/ExpectedDeliveryDate/Detail/index.vue')
      },
      {
        path: '/sendGoodsStrategy',
        component: () => import('@/views/Chief/contract/send-goods-strategy/index.vue'),
        name: 'sendGoodsStrategy',
        props: true,
        meta: {
          title: '申请发货'
        }
      },
      {
        path: 'creditControlApplication',
        component: () => import('../views/creditCenter/myApplication'),
        name: 'creditControlApplication',
        meta: {
          title: '信控申请',
          props: true
        }
      },
      {
        path: 'creditControlApplicationDetail',
        component: () => import('../views/creditCenter/myApplicationDetail'),
        name: 'creditControlApplicationDetail',
        meta: {
          title: '信控查看',
          props: true
        }
      }
    ]
  }
];
const errorPage = [
  {
    path: '/403',
    name: '403',
    component: notAllow
  },
  {
    path: '/404',
    name: '404',
    component: notFind
  },
  {
    path: '/changeUser',
    name: 'changeUser',
    meta: {
      title: '切换用户'
    },
    component: () => import('@/views/changeUser.vue')
  },
  {
    path: '/changeChannel',
    name: 'changeChannel',
    meta: {
      title: '切换渠道'
    },
    component: () => import('@/views/changeChannel.vue')
  },
  {
    path: '/shutDown',
    name: 'shutDown',
    component: () => import('../shutDown.vue')
  },
  {
    path: '/contractAgreementPrint/:contractNum',
    name: 'contractAgreementPrint',
    props: true,
    component: () => import('../views/Chief/contract/contractAgreement.vue'),
    meta: {
      title: '打印合同',
      active: 'ChiefContractList'
    }
  },
  {
    path: '/toLoginPage',
    name: 'toLoginPage',
    component: () => import('../views/toLoginPage.vue'),
    meta: {
      title: '跳转登录页面'
    }
  }
];
export const routes = [
  ...layoutRoute,
  ...otherMainLayout,
  ...errorPage
];

// 维护界面
export const shutDown = [
  {
    path: '*',
    redirect: 'shutDown'
  },
  {
    path: '/shutDown',
    name: 'shutDown',
    component: () => import('../shutDown.vue')
  }
];

export default routes;
